


// Logout
export function logoutUser() {
  // delete applied filters from local storage
  window.localStorage.removeItem('savedFilters');
  // AuthService.logout();
  window.location.replace('/logout');
}

export function getUserToken() {

  const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`))
  let userToken = {};
  if(!!oidcStorage) {
    userToken['value'] = oidcStorage.access_token;
    userToken['type'] = oidcStorage.token_type;
  }
  //const userToken = tokenString ? JSON.parse(tokenString) : '';
  return userToken;

}
